var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "8.1278mm",
    height: "8.1278mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 813 813",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .fil0 {fill:#8654CC}\n    .fil1 {fill:#FFE3C7;fill-rule:nonzero}\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_437427160"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    width: 813,
    height: 813,
    rx: 151,
    ry: 151
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M339 383l30 0 0 -80 39 0 0 -28 -69 0 0 108zm-61 -86c12,0 19,5 21,16l-44 0c4,-10 12,-16 23,-16zm0 62c-14,0 -23,-10 -24,-25l73 0c0,0 1,-5 1,-11 0,-32 -20,-51 -50,-51 -31,0 -54,24 -54,57 0,33 22,56 54,56 30,0 49,-17 50,-42l-29 0c-2,10 -9,16 -21,16zm-106 -84l-20 66 -20 -66 -33 0 -17 108 28 0 10 -67 20 67 23 0 21 -69 10 69 28 0 -17 -108 -33 0zm280 85c-8,0 -11,-4 -11,-9 0,-5 2,-8 11,-10l25 -8 0 2c0,14 -11,25 -25,25zm11 -88c-32,0 -50,16 -49,42l30 0c1,-11 6,-16 19,-16 8,0 14,3 14,9 0,4 -2,5 -7,6l-25 7c-23,7 -34,17 -34,33 0,19 14,32 35,32 16,0 26,-6 31,-19l0 17 29 0 0 -72c0,-26 -17,-39 -43,-39zm189 139l0 28 30 0 0 80 30 0 0 -80 31 0 0 -28 -91 0zm-107 0l-33 0 -23 40 -12 0 0 -40 -29 0 0 108 29 0 0 -41 12 0 25 41 33 0 -33 -55 31 -53zm-276 85c-7,0 -11,-3 -11,-9 0,-5 3,-8 11,-10l26 -7 0 1c0,15 -11,25 -26,25zm11 -87c-32,0 -50,15 -49,42l31 0c0,-12 6,-17 18,-17 9,0 14,4 14,9 0,4 -1,5 -7,7l-24 6c-24,7 -35,17 -35,33 0,19 14,32 35,32 16,0 26,-6 32,-18l0 16 28 0 0 -72c0,-26 -16,-38 -43,-38zm107 85c-13,0 -21,-9 -21,-29 0,-19 8,-29 22,-29 12,0 20,10 20,29 0,20 -7,29 -21,29zm9 -85c-15,0 -25,7 -29,18l0 -16 -30 0 0 137 30 0 0 -45c4,11 15,18 29,18 24,0 41,-19 41,-56 0,-37 -17,-56 -41,-56zm-224 2l-20 66 -20 -66 -33 0 -17 108 28 0 10 -67 20 67 23 0 21 -68 10 68 28 0 -17 -108 -33 0zm424 23c12,0 19,5 21,16l-44 0c3,-11 11,-16 23,-16zm-1 61c-14,0 -23,-10 -24,-25l73 0c0,0 1,-5 1,-11 0,-32 -19,-50 -49,-50 -32,0 -54,23 -54,56 0,33 22,56 53,56 30,0 50,-17 50,-42l-29 0c-2,10 -9,16 -21,16z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSber);
export default __webpack_public_path__ + "static/media/iconSber.fb05fefeda08c9c9fbf4f03a74baabfe.svg";
export { ForwardRef as ReactComponent };